import { useState } from "react";
import api from "../../services/api";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import MiniFooter from "../../components/Layout/miniFooter";

export default function AffiliateRegister() {
  const [referralCode, setReferralCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!referralCode.trim()) return setMessage("Please enter a unique affiliate name.");

    try {
      setLoading(true);
      setMessage("");
      const res = await api.post("/referrals/register-affiliate", { referralCode: referralCode.trim().toLowerCase() });
      if (res.data.success) {
        setMessage("✅ Affiliate account created successfully!");
        setTimeout(() => window.location.reload(), 1200);
      } else setMessage(res.data.message || "Unable to register affiliate.");
    } catch (err) {
      console.error(err);
      setMessage("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  const cardStyle = {
    background: "#FFFFFF",
    border: "1px solid #E5E7EB",
    borderRadius: "12px",
    padding: "32px",
    maxWidth: "600px",
    margin: "0 auto",
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  };

  return (
    <DashboardLayout>
      <div style={{ background: "#F9FAFB", minHeight: "100vh", padding: "32px 24px", maxWidth: "1200px", margin: "0 auto" }}>
        <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#111827", marginBottom: "8px", textAlign: "center" }}>
          Affiliate Program
        </h1>
        <p style={{ color: "#6B7280", fontSize: "15px", textAlign: "center", marginBottom: "32px" }}>
          Join our affiliate program and earn commissions by referring new users to our platform.
        </p>

        <div style={cardStyle}>
          <h2 style={{ fontSize: "22px", fontWeight: "600", color: "#111827", marginBottom: "16px" }}>
            Become an Affiliate
          </h2>

          <form onSubmit={handleSubmit}>
            <label style={{ display: "block", fontSize: "12px", fontWeight: "500", color: "#6B7280", marginBottom: "6px", textTransform: "uppercase" }}>
              Enter your unique affiliate name
            </label>
            <input
              type="text"
              placeholder="e.g. "
              value={referralCode}
              onChange={(e) => setReferralCode(e.target.value)}
              style={{
                width: "100%",
                padding: "12px 14px",
                borderRadius: "8px",
                border: "1px solid #D1D5DB",
                marginBottom: "8px",
                fontSize: "14px",
              }}
            />
            <small style={{ display: "block", color: "#6B7280", marginBottom: "16px" }}>
              This will be used in your referral link. Choose a unique and memorable name.
            </small>
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "12px",
                background: "#3B82F6",
                color: "#FFFFFF",
                fontWeight: "600",
                borderRadius: "8px",
                border: "none",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "background 0.2s",
              }}
            >
              {loading ? "Registering..." : "Register as Affiliate"}
            </button>
          </form>

          {message && (
            <p style={{ marginTop: "16px", textAlign: "center", color: message.startsWith("✅") ? "#16A34A" : "#DC2626" }}>
              {message}
            </p>
          )}

          <ul style={{ marginTop: "24px", paddingLeft: "20px", color: "#374151", fontSize: "14px" }}>
            <li>Earn commission on every wallet fund from your referrals</li>
            <li>Get your unique referral link to share with your audience</li>
            <li>Track your earnings and referrals in real-time</li>
            <li>Withdraw your earnings anytime</li>
          </ul>

          <p style={{ marginTop: "24px", fontSize: "12px", color: "#6B7280", textAlign: "center" }}>
            By registering, you agree to our affiliate program terms and conditions. Your application will be reviewed by our team.
          </p>
        </div>
      </div>
              <MiniFooter />
    </DashboardLayout>
  );
}